import React, { Component } from "react";
import Gallery from '../global/Gallery';

export default class PageSplashCarousel extends Component {
  	
	render () {
		
		let block = this.props.block;
		let loaded = this.props.loaded;
		
		console.log('pageLoaded: ' + loaded);
		if (block) {
						
		    return (
			    
				<div className="c-page__block c-page__block--splash">
					
					<div className={'c-splash-carousel scope-' + block.text_color}>
						
						<Gallery gallery={block.slides} loaded={loaded}></Gallery>
						
					</div>
					
				</div>
				
			)
			
		} else {
			
			return null;
		
		}
	}
}
